import Login from '../../pages/Login'
import UsersManager from '../../pages/UsersManager'
import UsersManagerDetail from '../../pages/UsersManager/UsersManagerDetail'
import RolesManager from '../../pages/RolesManager'
import Home from '../../pages/Home'
import TagsManager from '../../pages/TagsManager'
import Maintenance from '../../components/Maintenance'
import MyAccount from '../../pages/MyAccount'
import Consignation from '../../pages/Consignations'
import RecapStock from '../../pages/RecapStock/RecapStock'
import SalesHistoryManager from '../../pages/SalesHistoryManager'
import ScheduledPricesManager from '../../pages/ScheduledPricesManager'
import PricesManagerByArticle from '../../pages/PricesManagerByArticle'
import kioskPricesManager from '../../pages/KioskPricesManager/KioskPricesManager'
import Rgpd from '../../pages/Rgpd/Rgpd'
import LogExtranetManager from '../../pages/LogExtranetManager/LogExtranetManager'
import LogKioskManager from '../../pages/LogKioskManager/LogKioskManager'
import LogSynchroManager from '../../pages/LogSynchroManager/LogSynchroManager'
import LogUserManager from '../../pages/LogUserManager/LogUserManager'
import TelecollectManager from '../../pages/TelecollectManager/TelecollectManager'
import SalesHistoryByCodes from '../../pages/SalesHistoryByCodes/SalesHistoryByCodes'
import TicketCodes from '../../components/TicketCodes/TicketCodes'
import SalesHistoryByArticleManager from '../../pages/SalesByArticleHistoryManager'
import TelecollectDetail from '../../pages/TelecollectManager/TelecollectDetail/TelecollectDetail'
import ScheduledPromoManager from '../../pages/ScheduledPromoManager/ScheduledPromoManager'
import DistributionGroupRepo from '../../pages/DistributionGroupRepository/DistributionGroupRepository'
import DistributionGroupRepoDetail from '../../pages/DistributionGroupRepository/DistributionGroupRepositoryDetail/DistributionGroupRepositoryDetail'
import ArticleManager from '../../pages/ArticleManager/ArticleManager'
import AddItemCatalog from '../../pages/AddItemCatalog'
import CompaniesManager from '../../pages/CompaniesManager/CompaniesManager'
import CompanyDetail from '../../pages/CompanyDetail/CompanyDetail'
import TranslationsManager from '../../pages/TranslationsManager/TranslationsManager'
import LanguagesManager from '../../pages/LanguagesManager/LanguagesManager'
import UserPreferences from '../../pages/UserPreferences/UserPreferences'
import ArticleLifeManager from '../../pages/ArticleLifeManager'
import InitKioskBusinessManager from '../../pages/InitKioskBusinessManager'
import InitKioskCustomerManager from '../../pages/InitKioskCustomerManager'
import KioskCreationDefinitionCustomer from '../../pages/KioskCreation/KioskCreationDefinitionCustomer'
import KioskBankDetails from '../../pages/KioskBankDetails/KioskBankDetails'
import KioskAddItem from '../../pages/KioskAddItem/KioskAddItem'
import KioskCreationDefinitionBusiness from '../../pages/KioskCreation/KioskCreationDefinitionBusiness'
import KioskAddPrices from '../../pages/KioskAddPrices/KioskAddPrices'
import KioskImplantation from '../../pages/KioskImplantation/KioskImplantation'
import KioskSummary from '../../pages/KioskSummary'
import MarketingManager from '../../pages/Marketing'
import KioskProductionList from '../../pages/KioskProductionList'
import KioskDiagnostic from '../../pages/KioskDiagnostic/KioskDiagnostic'
import ItemCatalogDetail from '../../pages/ItemCatalog/ItemCatalogDetail/ItemCatalogDetail'
import ItemCatalog from '../../pages/ItemCatalog/ItemCatalog'
import KioskEditSetUp from '../../pages/KioskProductionList/KioskProductionDetail/KioskEditSetUp'
import KioskRacksRequest from '../../pages/KioskRacksRequest/KioskRacksRequest'
import KioskEditImplantation from '../../pages/KioskEditImplantation/KioskEditImplantation'
import LanguagesManagerDetail from '../../pages/LanguagesManager/LanguagesManagerDetail'
import TelecollectTicket from '../../pages/TelecollectManager/TelecollectTicket/TelecollectTicket'
import SalesControl from '../../pages/SalesControl/SalesControl'

export const uriList = {
	home: '/home',
	login: '/login',
	users: '/users',
	criticalError: '/critical-error',
	usersManager: '/manager',
	usersManagerCreate: '/users-create',
	usersManagerEdit: '/users-edit',
	rolesManager: '/roles',
	tags: '/tags',
	tagsUsersManager: '/users-manager',
	tagsKiosksManager: '/kiosks-manager',
	maintenance: '/maintenance',
	myAccount: '/my-account',
	myAccountEdit: '/account-edit',
	consignation: '/consignation',
	recapStock: '/stock-manager',
	sales: '/sales',
	salesHistory: '/sales-history',
	prices: '/prices',
	scheduledPricesManager: '/scheduled-prices-manager',
	scheduledPromoManager: '/scheduled-promo-manager',
	pricesManagerByArticle: '/prices-manager-article',
	kioskPricesManager: '/kiosk-prices-manager',
	log: '/log',
	logExtranetManager: '/log-extranet-manager',
	logKioskManager: '/log-kiosk-manager',
	logSynchroManager: '/log-synchro-manager',
	logUserManager: '/log-user-manager',
	rgpd: '/rgpd',
	telecollectManager: '/telecollect-manager',
	telecollectDetail: '/telecollect-detail',
	salesByArticleHistory: '/sales-by-article-history',
	salesHistoryByCodes: '/sales-codes-history',
	ticketCodes: '/current-user/codes',
	distributionItems: '/items',
	distributionItem: '/item',
	distributionEdit: '/edit',
	distributionGroupRepo: '/distribution-group-repository',
	distributionGroupRepositorytDetail: '/distribution-detail',
	articleCreate: '/article-create',
	articleEdit: '/article-edit',
	catalog: '/catalog',
	addItemCatalog: '/add-item-catalog',
	companies: '/companies',
	companiesManager: '/companies-manager',
	companiesCreate: '/companies-create',
	companiesEdit: '/companies-edit',
	translationsManager: '/translations-manager',
	languages: '/languages',
	languagesManager: '/languages-manager',
	preferences: '/preferences',
	userPreferencesEdit: '/user-preferences-edit',
	articleLife: '/article-life',
	article: '/article',
	initKiosks: '/init-kiosks',
	initKioskBusinessManager: '/init-kiosk-business',
	initKioskCustomerManager: '/init-kiosk-customer',
	kioskCreation: '/kiosk-creation',
	kioskCreationDefinition: '/kiosk-definition',
	kioskBankDetails: '/kiosk-bank-details',
	kioskAddItem: '/kiosk-add-item',
	kioskAddPrices: '/kiosk-add-prices',
	kioskImplantation: '/kiosk-implantation',
	kioskSummary: '/kiosk-summary',
	kiosksInProduction: '/kiosks',
	kioskProductionList: '/kiosk-production-list',
	kiosk: '/kiosk',
	kioskDiagnostic: '/kiosk-diagnostic-log',
	marketingManager: '/marketing',
	itemCatalogDetail: '/item-catalog-detail',
	itemCatalog: '/item-catalog',
	kioskProductionDetail: '/kiosk-production-detail',
	kioskEditSetUp: '/kiosk-edit-setup',
	kioskRacksRequest: '/kiosk-racks-request',
	kioskEditImplantation: '/kiosk-edit-implantation',
	languagesManagerCreate: '/languages-create',
	languagesManagerEdit: '/languages-edit',
	telecollectTicket: '/telecollect-ticket',
	salesControl: '/sales-control',
	salesControlList: '/sales-control-list',
}

const routeList = [
	{
		path: uriList.login,
		pathName: uriList.login,
		breadCrumb: 'login',
		isProtected: false,
		auth: '',
		component: Login,
		layout: false,
	},
	{
		path: uriList.maintenance,
		pathName: uriList.maintenance,
		breadCrumb: 'maintenance',
		isProtected: false,
		auth: '',
		component: Maintenance,
		layout: false,
	},
	{
		path: uriList.home,
		pathName: uriList.home,
		breadCrumb: 'header__breadcrumb__admin__home_home',
		isProtected: true,
		auth: '',
		component: Home,
		layout: true,
		backPage: true,
	},
	{
		path: uriList.users,
		pathName: uriList.users,
		breadCrumb: 'header__breadcrumb__admin__administration_main',
		isProtected: true,
		auth: 'extranet__admin__usersManagement_view',
		layout: true,
		routes: [
			{
				path: uriList.usersManager,
				pathName: uriList.usersManager,
				breadCrumb: 'header__breadcrumb__admin__administration_users',
				tabName: 'page__userManagement__userTable_title',
				isProtected: true,
				auth: 'extranet__admin__usersManagement_view',
				component: UsersManager,
				layout: true,
				routes: [
					{
						path: uriList.usersManagerCreate,
						pathName: uriList.usersManagerCreate,
						breadCrumb: 'header__breadcrumb__admin__administration__users_create',
						isProtected: true,
						tabName: 'page__userDetail__admin__userCreation_title',
						auth: 'extranet__admin__usersManagement_manage',
						component: UsersManagerDetail,
						layout: true,
						backPage: true,
						hidingSiblings: true,
					},
					{
						path: `${uriList.usersManagerEdit}/:id`,
						pathName: uriList.usersManagerEdit,
						breadCrumb: 'header__breadcrumb__admin__administration__users_update',
						isProtected: true,
						tabName: 'page__userDetail__admin__userUpdate_title',
						auth: 'extranet__admin__usersManagement_manage',
						component: UsersManagerDetail,
						layout: true,
						backPage: true,
						hidingSiblings: true,
					},
				],
			},
			{
				path: uriList.rolesManager,
				pathName: uriList.rolesManager,
				breadCrumb: 'header__breadcrumb__admin__administration_roles',
				tabName: 'page__roleManagement__rolePage_title',
				isProtected: true,
				auth: 'extranet__admin__rolesManagement_view',
				component: RolesManager,
				layout: true,
			},
		],
	},
	/*{
		path: uriList.usersManagerCreate,
		pathName: uriList.usersManagerCreate,
		breadCrumb: "header__breadcrumb__admin__administration_users",
		isProtected: true,
		auth: 'extranet__admin__usersManagement_manage',
		layout: true,
		backPage:true,
		parentBreadCrumb: 'header__breadcrumb__admin__administration_main',
		routes: [
			{
				path: '',
				pathName: '',
				breadCrumb: "header__breadcrumb__admin__administration__users_create",
				isProtected: true,
				tabName:"page__userDetail__admin__userCreation_title",
				auth: 'extranet__admin__usersManagement_manage',
				component: UsersManagerDetail,
				layout: true,
				backPage:true,
			},
		]
	},*/
	{
		path: uriList.distributionItems,
		pathName: uriList.distributionItems,
		breadCrumb: 'header__breadcrumb__admin__items_main',
		isProtected: true,
		auth: '',
		layout: true,
		routes: [
			{
				path: uriList.distributionGroupRepo,
				pathName: uriList.distributionGroupRepo,
				breadCrumb: 'header__breadcrumb__admin__items__referential_main',
				isProtected: true,
				tabName: 'page__itemReferential__tab__referential',
				auth: 'extranet__admin__itemsRef_view',
				component: DistributionGroupRepo,
				layout: true,
			},
		],
	},
	{
		path: uriList.catalog,
		pathName: uriList.catalog,
		breadCrumb: 'header__breadcrumb__admin__itemCatalog_main',
		isProtected: true,
		auth: '',
		layout: true,
		routes: [
			{
				path: uriList.addItemCatalog,
				pathName: uriList.addItemCatalog,
				breadCrumb: 'header__breadcrumb__admin__itemCatalog__distributor_link',
				isProtected: true,
				tabName: 'page__itemCatalog__tab__distributor_link',
				auth: 'extranet__admin__itemsCatalog_link_view',
				component: AddItemCatalog,
				layout: true,
			},
		],
	},
	{
		path: uriList.distributionItem,
		pathName: uriList.distributionItem,
		breadCrumb: 'header__breadcrumb__admin__items__referential_main',
		isProtected: true,
		auth: 'extranet__admin__itemsRef_view',
		layout: true,
		routes: [
			{
				path: `${uriList.distributionGroupRepositorytDetail}/:id`,
				pathName: uriList.distributionGroupRepositorytDetail,
				breadCrumb: 'header__breadcrumb__admin__items__referential_detail',
				isProtected: true,
				tabName: 'page__itemReferential__tab__detail',
				auth: 'extranet__admin__itemsRef_view',
				component: DistributionGroupRepoDetail,
				layout: true,
				backPage: true,
			},
		],
	},
	/*{
		path: `${uriList.usersManagerEdit}/:id`,
		pathName: uriList.usersManagerEdit,
		breadCrumb: "header__breadcrumb__admin__administration_users",
		isProtected: true,
		auth: 'extranet__admin__usersManagement_manage',
		layout: true,
		backPage:true,
		parentBreadCrumb: 'header__breadcrumb__admin__administration_main',
		routes: [
			{
				path: '',
				pathName: '',
				breadCrumb: "header__breadcrumb__admin__administration__users_update",
				isProtected: true,
				tabName:"page__userDetail__admin__userUpdate_title",
				auth: 'extranet__admin__usersManagement_manage',
				component: UsersManagerDetail,
				layout: true,
				backPage:true,
			},
		]
	},*/

	{
		path: uriList.myAccount,
		pathName: uriList.myAccount,
		breadCrumb: 'header__breadcrumb__admin__administration__users_myAccount',
		isProtected: true,
		auth: 'extranet__admin__menu_myAccount_view',
		layout: true,
		routes: [
			{
				path: uriList.myAccountEdit,
				pathName: uriList.myAccountEdit,
				breadCrumb: 'header__breadcrumb__admin__administration__users_update',
				isProtected: true,
				//tabName: 'Modification compte utilisateur',
				tabName: 'page__tagManagement__user_edit_header',
				auth: 'extranet__admin__menu_myAccount_view',
				component: MyAccount,
				layout: true,
			},
		],
	},

	{
		path: uriList.tags,
		pathName: uriList.tags,
		breadCrumb: 'header__breadcrumb__admin__administration_main',
		isProtected: true,
		auth: 'extranet__admin__tagsManagement_view',
		layout: true,
		routes: [
			{
				path: uriList.tagsUsersManager,
				pathName: uriList.tagsUsersManager,
				breadCrumb: 'header__breadcrumb__admin__administration_tags',
				tabName: 'page__tagManagement__user_header',
				isProtected: true,
				auth: 'extranet__admin__tagsManagement_view',
				component: TagsManager,
				layout: true,
			},
			{
				path: uriList.tagsKiosksManager,
				pathName: uriList.tagsKiosksManager,
				breadCrumb: 'header__breadcrumb__admin__administration_tags',
				tabName: 'page__tagManagement__kiosk_header',
				isProtected: true,
				auth: 'extranet__admin__tagsManagement_view',
				component: TagsManager,
				layout: true,
			},
		],
	},

	{
		path: uriList.recapStock,
		pathName: uriList.recapStock,
		breadCrumb: 'header__breadcrumb__admin__stocks_main',
		isProtected: true,
		auth: 'extranet__admin__stockManagement_view',
		layout: true,
		routes: [
			{
				path: '',
				pathName: '',
				breadCrumb: 'header__breadcrumb__admin__stocks_summary',
				tabName: 'page__stockManagement__admin__itemTable_title',
				isProtected: true,
				auth: 'extranet__admin__stockManagement_view',
				component: RecapStock,
				layout: true,
			},
		],
	},

	{
		path: uriList.sales,
		pathName: uriList.sales,
		breadCrumb: 'header__breadcrumb__admin__salesOrders_main',
		isProtected: true,
		auth: 'extranet__admin__salesOrder_history_byKiosk_view',
		layout: true,
		routes: [
			{
				path: uriList.salesHistory,
				pathName: uriList.salesHistory,
				breadCrumb: 'header__breadcrumb__admin__salesOrders_byKiosk',
				tabName: 'page__transactionsHistory__tab__salesOrder',
				isProtected: true,
				auth: 'extranet__admin__salesOrder_history_byKiosk_view',
				component: SalesHistoryManager,
				layout: true,
			},
			{
				path: uriList.salesByArticleHistory,
				pathName: uriList.salesByArticleHistory,
				breadCrumb: 'header__breadcrumb__admin__salesOrders_byItem',
				tabName: 'page__transactionsHistory__tab__salesOrder_byItem',
				isProtected: true,
				auth: 'extranet__admin__salesOrder_byItem_view',
				component: SalesHistoryByArticleManager,
				layout: true,
			},
			{
				path: uriList.consignation,
				pathName: uriList.consignation,
				breadCrumb: 'header__breadcrumb__admin__salesOrders_consignment',
				tabName: 'page__transactionsHistory__tab__consignementContract',
				isProtected: true,
				auth: 'extranet__admin__depositContract_view',
				component: Consignation,
				layout: true,
			},
			{
				path: uriList.marketingManager,
				pathName: uriList.marketingManager,
				breadCrumb: 'header__breadcrumb__admin__salesOrder_marketing',
				tabName: 'page__transactionsHistory__tab__marketing',
				isProtected: true,
				auth: 'extranet__admin__marketing_view',
				component: MarketingManager,
				layout: true,
			},
			{
				path: uriList.telecollectManager,
				pathName: uriList.telecollectManager,
				breadCrumb: 'header__breadcrumb__admin__salesOrders_paymentCollection',
				tabName: 'page__transactionsHistory__tab__paymentCollection',
				isProtected: true,
				auth: 'extranet__admin__paimentCollectionHistory_view',
				component: TelecollectManager,
				layout: true,
				routes: [
					{
						path: `${uriList.telecollectTicket}/:id`,
						pathName: uriList.telecollectTicket,
						breadCrumb: '',
						isProtected: true,
						auth: 'extranet__admin__paimentCollectionHistory_view',
						component: TelecollectTicket,
						layout: false,
					},
				],
			},
			{
				path: uriList.salesHistoryByCodes,
				pathName: uriList.salesHistoryByCodes,
				breadCrumb: 'header__breadcrumb__admin__salesOrders_byCode',
				tabName: 'page__transactionsHistory__tab__salesOrderByCode',
				isProtected: true,
				auth: 'extranet__admin__salesOrder_history_byCode_view',
				component: SalesHistoryByCodes,
				layout: true,
			},
		],
	},

	{
		path: `${uriList.ticketCodes}/:id`,
		pathName: uriList.ticketCodes,
		breadCrumb: '',
		isProtected: true,
		auth: 'extranet__admin__salesOrder_byCode_manage',
		component: TicketCodes,
		layout: false,
	},

	{
		path: `${uriList.telecollectDetail}/:id`,
		pathName: uriList.telecollectDetail,
		breadCrumb: 'header__breadcrumb__admin__salesOrders_paymentCollection',
		isProtected: true,
		auth: 'extranet__admin__paimentCollectionDetail_view',
		layout: true,
		backPage: true,
		parentBreadCrumb: 'header__breadcrumb__admin__salesOrders_main',
		routes: [
			{
				path: '',
				pathName: '',
				breadCrumb: 'header__breadcrumb__admin__salesOrders__paymentCollection_detail',
				isProtected: true,
				tabName: 'page__paymentCollectionManagement__detail__title',
				auth: 'extranet__admin__paimentCollectionDetail_view',
				component: TelecollectDetail,
				layout: true,
				backPage: true,
			},
		],
	},
	{
		path: uriList.prices,
		pathName: uriList.prices,
		breadCrumb: 'header__breadcrumb__admin__prices_main',
		isProtected: true,
		auth: 'extranet__admin__pricesChange_view',
		layout: true,
		routes: [
			{
				path: uriList.kioskPricesManager,
				pathName: uriList.kioskPricesManager,
				breadCrumb: 'header__breadcrumb__admin__prices_byKiosk',
				tabName: 'page__pricesManagement__tab__pricesByKiosk',
				isProtected: true,
				auth: 'extranet__admin__pricesByKiosk_view',
				component: kioskPricesManager,
				layout: true,
			},
			{
				path: uriList.pricesManagerByArticle,
				pathName: uriList.pricesManagerByArticle,
				breadCrumb: 'header__breadcrumb__admin__prices_byItem',
				tabName: 'page__pricesManagement__tab__pricesByItem',
				isProtected: true,
				auth: 'extranet__admin__pricesByItem_view',
				component: PricesManagerByArticle,
				layout: true,
			},
			{
				path: uriList.scheduledPricesManager,
				pathName: uriList.scheduledPricesManager,
				breadCrumb: 'header__breadcrumb__admin__prices_priceUpdate',
				tabName: 'page__pricesManagement__tab__pricesCampaign',
				isProtected: true,
				auth: 'extranet__admin__pricesChange_view',
				component: ScheduledPricesManager,
				layout: true,
			},
			{
				path: uriList.scheduledPromoManager,
				pathName: uriList.scheduledPromoManager,
				breadCrumb: 'header__breadcrumb__admin__prices_promotion',
				tabName: 'page__pricesManagement__tab__pricesPromotions',
				isProtected: true,
				auth: 'extranet__admin__pricesChange_view',
				component: ScheduledPromoManager,
				layout: true,
			},
		],
	},
	{
		path: uriList.log,
		pathName: uriList.log,
		breadCrumb: 'header__breadcrumb__admin__administration_main',
		isProtected: true,
		auth: '',
		layout: true,
		routes: [
			{
				path: uriList.logUserManager,
				pathName: uriList.logUserManager,
				breadCrumb: 'header__breadcrumb__admin__administration__logs_users',
				tabName: 'page__logAdmin__header_user',
				isProtected: true,
				auth: 'extranet__admin__logsHistory_users_view',
				component: LogUserManager,
				layout: true,
			},
			{
				path: uriList.logKioskManager,
				pathName: uriList.logKioskManager,
				breadCrumb: 'header__breadcrumb__admin__administration__logs_kiosk',
				tabName: 'page__logAdmin__header_kiosk',
				isProtected: true,
				auth: 'extranet__admin__logsHistory_kiosk_view',
				component: LogKioskManager,
				layout: true,
			},
			{
				path: uriList.logSynchroManager,
				pathName: uriList.logSynchroManager,
				breadCrumb: 'header__breadcrumb__admin__administration__logs_synchro',
				tabName: 'page__logAdmin__header_synchro',
				isProtected: true,
				auth: 'extranet__admin__logsHistory_synchro_view',
				component: LogSynchroManager,
				layout: true,
			},
			{
				path: uriList.logExtranetManager,
				pathName: uriList.logExtranetManager,
				breadCrumb: 'header__breadcrumb__admin__administration__logs_extraNet',
				tabName: 'page__logAdmin__header_extranet',
				isProtected: true,
				auth: 'extranet__admin__logsHistory_extranet_view',
				component: LogExtranetManager,
				layout: true,
			},
		],
	},
	{
		path: uriList.rgpd,
		pathName: uriList.rgpd,
		breadCrumb: 'header__breadcrumb__admin__administration_main',
		isProtected: true,
		auth: 'extranet__admin__rgpdManagement_view',
		layout: true,
		routes: [
			{
				path: '',
				pathName: '',
				breadCrumb: 'header__breadcrumb__admin__administration_rgpd',
				tabName: 'page__rgpd__title',
				isProtected: true,
				auth: 'extranet__admin__rgpdManagement_view',
				component: Rgpd,
				layout: true,
			},
		],
	},
	/*{
		path: uriList.articleCreate,
		pathName: uriList.articleCreate,
		breadCrumb: "header__breadcrumb__admin__items_main",
		isProtected: true,
		auth: 'extranet__admin__itemsRef_manage',
		layout: true,
		backPage:true,
		routes: [
			{
				path:'',
				pathName: '',
				breadCrumb: "header__breadcrumb__admin__items__referential_create",
				isProtected: true,
				tabName:'page__admin__items__tab__referentialCreate',
				auth: 'extranet__admin__itemsRef_manage',
				component: ArticleManager,
				layout: true,
				backPage:true,
			},
		]
	},*/
	{
		path: uriList.article,
		pathName: '',
		breadCrumb: 'header__breadcrumb__admin__items__referential_main',
		isProtected: true,
		auth: 'extranet__admin__itemsRef_view',
		layout: true,
		backPage: true,
		parentBreadCrumb: 'header__breadcrumb__admin__items_main',
		routes: [
			{
				path: `${uriList.articleEdit}/:id`,
				pathName: uriList.articleEdit,
				breadCrumb: 'header__breadcrumb__admin__items__referential_update',
				isProtected: true,
				tabName: 'page__admin__items__tab__referentialUpdate',
				auth: 'extranet__admin__itemsRef_manage',
				component: ArticleManager,
				layout: true,
				backPage: true,
			},
			{
				path: `${uriList.articleLife}/:id`,
				pathName: uriList.articleLife,
				breadCrumb: 'header__breadcrumb_admin_item_timeline',
				isProtected: true,
				tabName: 'page__itemRef__timeline_tab',
				auth: 'extranet__admin__itemsRef_view',
				component: ArticleLifeManager,
				layout: true,
				backPage: true,
			},
			{
				path: uriList.articleCreate,
				pathName: uriList.articleCreate,
				breadCrumb: 'header__breadcrumb__admin__items__referential_create',
				isProtected: true,
				tabName: 'page__admin__items__tab__referentialCreate',
				auth: 'extranet__admin__itemsRef_manage',
				component: ArticleManager,
				layout: true,
				backPage: true,
				hidingSiblings: true,
			},
		],
	},
	{
		path: uriList.companies,
		pathName: uriList.companies,
		breadCrumb: 'header__breadcrumb__admin__administration_main',
		isProtected: true,
		auth: 'extranet__admin__companiesManagement_view',
		layout: true,
		routes: [
			/*{
				path: "",
				pathName: "",
				breadCrumb: "header__breadcrumb_companies_management",
				tabName: 'page__companiesManagement__title',
				isProtected: true,
				auth: 'extranet__admin__companiesManagement_view',
				component: CompaniesManager,
				layout: true,
			},*/
			{
				path: uriList.companiesManager,
				pathName: uriList.companiesManager,
				breadCrumb: 'header__breadcrumb_companies_management',
				tabName: 'page__companiesManagement__title',
				isProtected: true,
				auth: 'extranet__admin__companiesManagement_view',
				component: CompaniesManager,
				layout: true,
				parentBreadCrumb: 'header__breadcrumb__admin__administration_main',
				routes: [
					{
						path: uriList.companiesCreate,
						pathName: uriList.companiesCreate,
						breadCrumb: 'header__breadcrumb_companies_create_modify',
						isProtected: true,
						tabName: 'page__companiesManagement__create_title',
						auth: 'extranet__admin__companiesManagement_manage',
						component: CompanyDetail,
						layout: true,
						backPage: true,
						hidingSiblings: true,
					},
					{
						path: `${uriList.companiesEdit}/:id`,
						pathName: uriList.companiesEdit,
						breadCrumb: 'header__breadcrumb_companies_create_modify',
						isProtected: true,
						tabName: 'page__companiesManagement__modify_title',
						auth: 'extranet__admin__companiesManagement_manage',
						component: CompanyDetail,
						layout: true,
						backPage: true,
						hidingSiblings: true,
					},
				],
			},
		],
	},
	/*{
		path: uriList.companiesManager,
		pathName: uriList.companiesManager,
		breadCrumb: "header__breadcrumb_companies_management",
		tabName: 'page__companiesManagement__title',
		isProtected: true,
		auth: 'extranet__admin__companiesManagement_view',
		component: CompaniesManager,
		layout: true,
		parentBreadCrumb: 'header__breadcrumb__admin__administration_main',
		routes:[
			{
				path: uriList.companiesCreate,
				pathName: uriList.companiesCreate,
				breadCrumb: "header__breadcrumb_companies_create_modify",
				isProtected: true,
				tabName:"page__companiesManagement__create_title",
				auth: 'extranet__admin__companiesManagement_manage',
				component: CompanyDetail,
				layout: true,
				backPage:true,
				hidingSiblings:true,
			},
			{
				path: `${uriList.companiesEdit}/:id`,
				pathName: uriList.companiesEdit,
				breadCrumb: "header__breadcrumb_companies_create_modify",
				isProtected: true,
				tabName:"page__companiesManagement__modify_title",
				auth: 'extranet__admin__companiesManagement_manage',
				component: CompanyDetail,
				layout: true,
				backPage:true,
				hidingSiblings: true,
			},
		]
	},*/
	/*{
		path: uriList.companiesCreate,
		pathName: uriList.companiesCreate,
		breadCrumb: "header__breadcrumb_companies_management",
		isProtected: true,
		auth: 'extranet__admin__companiesManagement_manage',
		layout: true,
		backPage:true,
		parentBreadCrumb: 'header__breadcrumb__admin__administration_main',
		routes: [
			{
				path: '',
				pathName: '',
				breadCrumb: "header__breadcrumb_companies_create_modify",
				isProtected: true,
				tabName:"page__companiesManagement__create_title",
				auth: 'extranet__admin__companiesManagement_manage',
				component: CompanyDetail,
				layout: true,
				backPage:true,
			},
		]
	},
	{
		path: `${uriList.companiesEdit}/:id`,
		pathName: uriList.companiesEdit,
		breadCrumb: "header__breadcrumb_companies_management",
		isProtected: true,
		auth: 'extranet__admin__companiesManagement_manage',
		layout: true,
		backPage:true,
		parentBreadCrumb: 'header__breadcrumb__admin__administration_main',
		routes: [
			{
				path: '',
				pathName: '',
				breadCrumb: "header__breadcrumb_companies_create_modify",
				isProtected: true,
				tabName:"page__companiesManagement__modify_title",
				auth: 'extranet__admin__companiesManagement_manage',
				component: CompanyDetail,
				layout: true,
				backPage:true,
			},
		]
	},*/
	{
		path: uriList.languages,
		pathName: uriList.languages,
		breadCrumb: 'header__breadcrumb__admin__administration_main',
		isProtected: true,
		auth: 'extranet__admin__languageManagement_view',
		layout: true,
		routes: [
			{
				path: uriList.languagesManager,
				pathName: uriList.languagesManager,
				breadCrumb: 'header__breadcrumb__admin__administration_languages',
				tabName: 'page__languageManagement__tab',
				isProtected: true,
				auth: 'extranet__admin__languageManagement_view',
				component: LanguagesManager,
				layout: true,
				routes: [
					{
						path: uriList.languagesManagerCreate,
						pathName: uriList.languagesManagerCreate,
						breadCrumb: 'header__breadcrumb__admin__administration_languages_create',
						isProtected: true,
						tabName: 'page__languagesManagement__create_title',
						auth: 'extranet__admin__languageManagement_manage',
						component: LanguagesManagerDetail,
						layout: true,
						backPage: true,
						hidingSiblings: true,
					},
					{
						path: `${uriList.languagesManagerEdit}/:id`,
						pathName: uriList.languagesManagerEdit,
						breadCrumb: 'header__breadcrumb__admin__administration_languages_update',
						isProtected: true,
						tabName: 'page__languagesManagement__modify_title',
						auth: 'extranet__admin__languageManagement_manage',
						component: LanguagesManagerDetail,
						layout: true,
						backPage: true,
						hidingSiblings: true,
					},
				],
			},
			{
				path: uriList.translationsManager,
				pathName: uriList.translationsManager,
				breadCrumb: 'header__breadcrumb_language__translationManagement',
				tabName: 'page__translationManagement__tab',
				isProtected: true,
				auth: 'extranet__admin__traductionManagement_view',
				component: TranslationsManager,
				layout: true,
			},
		],
	},
	{
		path: uriList.preferences,
		pathName: uriList.preferences,
		breadCrumb: 'header__breadcrumb__admin__preference_main',
		isProtected: true,
		auth: 'extranet__admin__menu_setting_view',
		layout: true,
		routes: [
			{
				path: uriList.userPreferencesEdit,
				pathName: uriList.userPreferencesEdit,
				breadCrumb: 'header__breadcrumb__admin__preference_manage',
				isProtected: true,
				tabName: 'page__admin__administration__tab__preferences',
				auth: 'extranet__admin__menu_setting_view',
				component: UserPreferences,
				layout: true,
			},
		],
	},
	{
		path: uriList.initKiosks,
		pathName: uriList.initKiosks,
		breadCrumb: 'header__breadcrumb_admin_initKiosk_kiosk',
		isProtected: true,
		auth: ['extranet__admin__kioskRequest_business_view', 'extranet__admin__kioskRequest_customer_view'],
		layout: true,
		routes: [
			{
				path: uriList.initKioskBusinessManager,
				pathName: uriList.initKioskBusinessManager,
				breadCrumb: 'header__breadcrumb_admin_initKiosk_kioskCreation',
				tabName: 'page__initKiosk__kioskCreation_tab',
				isProtected: true,
				auth: 'extranet__admin__kioskRequest_business_view',
				component: InitKioskBusinessManager,
				layout: true,
				tabNameRafters: true,
				statusPath: 'initKioskCreation.statusId',
				routes: [
					{
						path: uriList.kioskCreationDefinition,
						altPath: `${uriList.kioskCreationDefinition}/:id`,
						hasAltPath: true,
						pathName: uriList.kioskCreationDefinition,
						breadCrumb: 'header__breadcrumb_admin_initKiosk_stepOne',
						tabName: 'page__initKiosk__kioskCreation_kiosk_tab',
						isProtected: true,
						auth: 'extranet__admin__kioskRequest_business_manage_listInProgress',
						component: KioskCreationDefinitionBusiness,
						layout: true,
						backPage: true,
						statusVisible: 6,
						statusNext: 2,
						statusValidated: 2,
					},
					{
						path: `${uriList.kioskBankDetails}/:id`,
						pathName: uriList.kioskBankDetails,
						breadCrumb: 'header__breadcrumb_admin_initKiosk__kioskCreation_bankInformations',
						tabName: 'page__initKiosk__kioskCreation_bankInformations_tab',
						isProtected: true,
						auth: 'extranet__admin__kioskRequest_business_manage_listInProgress',
						component: KioskBankDetails,
						layout: true,
						backPage: true,
						statusVisible: 6,
						statusNext: 6,
						statusValidated: 7,
					},
					{
						path: `${uriList.kioskAddItem}/:id`,
						pathName: uriList.kioskAddItem,
						breadCrumb: 'header__breadcrumb_admin_initKiosk__kioskCreation_items',
						tabName: 'page__initKiosk__kioskCreation_items_tab',
						isProtected: true,
						auth: 'extranet__admin__kioskRequest_business_manage_listInProgress',
						component: KioskAddItem,
						layout: true,
						backPage: true,
						statusVisible: 6,
						statusNext: 7,
						statusValidated: 8,
					},
					{
						path: `${uriList.kioskImplantation}/:id`,
						pathName: uriList.kioskImplantation,
						breadCrumb: 'header__breadcrumb_admin_initKiosk_kioskCreation_growth',
						tabName: 'page__initKiosk__kioskCreation_growth_tab',
						isProtected: true,
						auth: 'extranet__admin__kioskRequest_business_manage_listInProgress',
						component: KioskImplantation,
						layout: true,
						backPage: true,
						statusVisible: 6,
						statusNext: 8,
						statusValidated: 9,
					},
					{
						path: `${uriList.kioskAddPrices}/:id`,
						pathName: uriList.kioskAddPrices,
						breadCrumb: 'header__breadcrumb_admin_initKiosk_prices',
						tabName: 'page__initKiosk__kioskCreation_prices_tab',
						isProtected: true,
						auth: 'extranet__admin__kioskRequest_business_manage_listInProgress',
						component: KioskAddPrices,
						layout: true,
						backPage: true,
						statusVisible: 6,
						statusNext: 9,
						statusValidated: 10,
					},
					{
						path: `${uriList.kioskSummary}/:id`,
						pathName: uriList.kioskSummary,
						breadCrumb: 'header__breadcrumb_admin_initKiosk__kioskCreation_summary',
						tabName: 'header__breadcrumb_admin_initKiosk__kioskCreation_tab',
						isProtected: true,
						auth: 'extranet__admin__kioskRequest_business_manage_listInProgress',
						component: KioskSummary,
						layout: true,
						backPage: true,
						statusVisible: 6,
						statusNext: 10,
						statusValidated: 11,
					},
				],
			},
			{
				path: uriList.initKioskCustomerManager,
				pathName: uriList.initKioskCustomerManager,
				breadCrumb: 'header__breadcrumb_admin_initKiosk_kioskCreation',
				tabName: 'page__initKiosk__kioskCreation_tab',
				isProtected: true,
				auth: 'extranet__admin__kioskRequest_customer_view',
				component: InitKioskCustomerManager,
				layout: true,
				tabNameRafters: true,
				statusPath: 'initKioskCreation.statusId',
				routes: [
					{
						path: uriList.kioskCreationDefinition,
						altPath: `${uriList.kioskCreationDefinition}/:id`,
						hasAltPath: true,
						pathName: uriList.kioskCreationDefinition,
						breadCrumb: 'header__breadcrumb_admin_initKiosk_stepOne',
						tabName: 'page__initKiosk__kioskCreation_kiosk_tab',
						isProtected: true,
						auth: 'extranet__admin__kioskRequest_customer_manage_listInProgress',
						component: KioskCreationDefinitionCustomer,
						layout: true,
						backPage: true,
						statusVisible: 6,
						statusNext: 2,
						statusValidated: 2,
					},
					{
						path: `${uriList.kioskBankDetails}/:id`,
						pathName: uriList.kioskBankDetails,
						breadCrumb: 'header__breadcrumb_admin_initKiosk__kioskCreation_bankInformations',
						tabName: 'page__initKiosk__kioskCreation_bankInformations_tab',
						tabNameRafters: true,
						isProtected: true,
						auth: 'extranet__admin__kioskRequest_customer_manage_listInProgress',
						component: KioskBankDetails,
						layout: true,
						backPage: true,
						statusVisible: 6,
						statusNext: 6,
						statusValidated: 7,
					},
					{
						path: `${uriList.kioskAddItem}/:id`,
						pathName: uriList.kioskAddItem,
						breadCrumb: 'header__breadcrumb_admin_initKiosk__kioskCreation_items',
						tabName: 'page__initKiosk__kioskCreation_items_tab',
						isProtected: true,
						auth: 'extranet__admin__kioskRequest_customer_manage_listInProgress',
						component: KioskAddItem,
						layout: true,
						backPage: true,
						statusVisible: 6,
						statusNext: 7,
						statusValidated: 8,
					},
					{
						path: `${uriList.kioskImplantation}/:id`,
						pathName: uriList.kioskImplantation,
						breadCrumb: 'header__breadcrumb_admin_initKiosk_kioskCreation_growth',
						tabName: 'page__initKiosk__kioskCreation_growth_tab',
						isProtected: true,
						auth: 'extranet__admin__kioskRequest_business_manage_listInProgress',
						component: KioskImplantation,
						layout: true,
						backPage: true,
						statusVisible: 6,
						statusNext: 8,
						statusValidated: 9,
					},
					{
						path: `${uriList.kioskAddPrices}/:id`,
						pathName: uriList.kioskAddPrices,
						breadCrumb: 'header__breadcrumb_admin_initKiosk_prices',
						tabName: 'page__initKiosk__kioskCreation_prices_tab',
						isProtected: true,
						auth: 'extranet__admin__kioskRequest_customer_manage_listInProgress',
						component: KioskAddPrices,
						layout: true,
						backPage: true,
						statusVisible: 6,
						statusNext: 9,
						statusValidated: 10,
					},
					{
						path: `${uriList.kioskSummary}/:id`,
						pathName: uriList.kioskSummary,
						breadCrumb: 'header__breadcrumb_admin_initKiosk__kioskCreation_summary',
						tabName: 'header__breadcrumb_admin_initKiosk__kioskCreation_tab',
						isProtected: true,
						auth: 'extranet__admin__kioskRequest_customer_manage_listInProgress',
						component: KioskSummary,
						layout: true,
						backPage: true,
						statusVisible: 6,
						statusNext: 10,
						statusValidated: 11,
					},
				],
			},
		],
	},
	{
		path: uriList.kiosksInProduction,
		pathName: uriList.kiosksInProduction,
		breadCrumb: 'header__breadcrumb_admin_initKiosk_kiosk',
		isProtected: true,
		auth: 'extranet__admin__initKiosksProduction_kioskList_view',
		layout: true,
		routes: [
			{
				path: uriList.kioskProductionList,
				pathName: uriList.kioskProductionList,
				breadCrumb: 'header__breadcrumb_admin_initKiosksProduction__kioskList',
				tabName: 'page__initKiosksProduction__kioskList_tab',
				isProtected: true,
				auth: 'extranet__admin__initKiosksProduction_kioskList_view',
				component: KioskProductionList,
				layout: true,
				routes: [
					{
						path: `${uriList.kioskDiagnostic}/:id`,
						pathName: uriList.kioskDiagnostic,
						breadCrumb: 'header__breadcrumb_admin_initKiosksProduction__kiosksLogShow',
						tabName: 'page__initKiosksProduction__kiosksLogShow_tab',
						isProtected: true,
						auth: 'extranet__admin__kioskLog_view',
						layout: true,
						component: KioskDiagnostic,
						backPage: true,
					},
					{
						path: `${uriList.kioskEditSetUp}/:id`,
						pathName: uriList.kioskEditSetUp,
						breadCrumb: 'header__breadcrumb__admin__kiosk__in__production__modify_summary',
						isProtected: true,
						tabName: 'page__kiosk__in__production__modify__admin__tab_title',
						auth: 'extranet__admin__kioskUpdate_view',
						component: KioskEditSetUp,
						layout: true,
						backPage: true,
					},
					{
						path: `${uriList.kioskRacksRequest}/:id`,
						pathName: uriList.kioskRacksRequest,
						breadCrumb: 'header__breadcrumb__admin__rackUpdate',
						tabName: 'page__admin__rackUpdate_tab_title',
						isProtected: true,
						auth: 'extranet__admin__rackUpdate_view',
						layout: true,
						component: KioskRacksRequest,
						backPage: true,
					},
					{
						path: `${uriList.kioskEditImplantation}/:id`,
						pathName: uriList.kioskEditImplantation,
						breadCrumb: 'header__breadcrumb__admin__kiosk__in__production__modify__implantation_summary',
						tabName: 'page__kiosk__in__production__modify__implantation__admin__tab_title',
						isProtected: true,
						auth: 'extranet__admin__kioskUpdateImplantation_view',
						layout: true,
						component: KioskEditImplantation,
						backPage: true,
					},
				],
			},
		],
	},
	{
		path: uriList.salesControl,
		pathName: uriList.salesControl,
		breadCrumb: 'header__breadcrumb_admin_initKiosk_kiosk',
		isProtected: true,
		auth: 'extranet__admin__kioskTransactionAnalysis_view',
		layout: true,
		routes: [
			{
				path: uriList.salesControlList,
				pathName: uriList.salesControlList,
				breadCrumb: 'page__kiosk__transactionAnalysis__summary',
				tabName: 'page__kiosk__transactionAnalysis__tab_title',
				isProtected: true,
				auth: 'extranet__admin__kioskTransactionAnalysis_view',
				component: SalesControl,
				layout: true,
				routes: [],
			},
		],
	},
	{
		path: uriList.itemCatalog,
		pathName: uriList.itemCatalog,
		breadCrumb: 'header__breadcrumb__admin__items_main',
		isProtected: true,
		auth: '',
		layout: true,
		routes: [
			{
				path: '',
				pathName: '',
				breadCrumb: 'header__breadcrumb__admin__itemCatalog_kiosk',
				isProtected: true,
				tabName: 'page__itemCatalog__kiosk__tab_title',
				auth: 'extranet__admin__kioskCatalog_view',
				component: ItemCatalog,
				layout: true,
				routes: [
					{
						path: `${uriList.itemCatalogDetail}/:id`,
						pathName: uriList.itemCatalogDetail,
						breadCrumb: 'header__breadcrumb__admin__items__referential_detail',
						isProtected: true,
						tabName: 'page__itemCatalog__kiosk_detail__tab_title',
						auth: '',
						component: ItemCatalogDetail,
						layout: true,
						backPage: true,
					},
				],
			},
		],
	},
	/* 	{
			path: uriList.kioskProductionDetail,
			pathName: uriList.kioskProductionDetail,
			breadCrumb: 'header__breadcrumb__admin__items_main',
			isProtected: true,
			auth: '',
			layout: true,
			routes: [
				{
					//path: `${uriList.kioskEditSetUp}/:id`,
					path: uriList.kioskEditSetUp,
					pathName: uriList.kioskEditSetUp,
					breadCrumb: 'header__breadcrumb__admin__items__referential_detail',
					isProtected: true,
					tabName: 'page__itemCatalog__kiosk_detail__tab_title',
					auth: '',
					component: ItemCatalogDetail,
					layout: true,
					backPage: true,
				},
			],
		},
	 */
]

export default routeList
